import { DATE_FORMAT_OPTIONS } from '../../constants/date-constants';
import { formatDate } from '../../utils';

/**
 * Tab label, e.g. "March 3, 2026_3:50 PM".
 * Rendered in the viewer's own locale and timezone via the shared `formatDate`
 */
export function formatExportTimestamp(createdAt: string): string {
  const date = formatDate(createdAt, DATE_FORMAT_OPTIONS.FULL_DATE);
  const time = formatDate(createdAt, { hour: 'numeric', minute: '2-digit' });
  // formatDate returns '' for an unparseable value — fall back to the raw string.
  return date && time ? `${date}_${time}` : createdAt;
}
export function formatExportFileTimestamp(when: Date = new Date()): string {
  const pad = (value: number) => String(value).padStart(2, '0');
  const date = `${when.getFullYear()}-${pad(when.getMonth() + 1)}-${pad(when.getDate())}`;
  const time = formatDate(when, { hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' }).replace(/:/g, '.').replace(/\s+/g, ' ').trim();
  return `${date} ${time}`;
}

/** Renders the "Export" column — which tabs a node came from, e.g. "1, 2, 3". */
export function formatExportNums(exportNums: number[]): string {
  return [...exportNums].sort((a, b) => a - b).join(', ');
}
